import { styled } from '@acko-tech/building-blocks.ui.common';

interface OverlayProps {
    title: string;
    feature: string;
    className?: string;
}

const OverlayContainer = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    color: var(--Text-White, #fff);
    padding: 20px;
    //border-radius: 10px;
    text-align: center;
    display: flex;
    gap: 12px;
    flex-direction: column;
    align-items: flex-start;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 5.21%,
        rgba(0, 0, 0, 0.6) 24.75%,
        #000 100%
    );

    &::after {
        content: '';
        width: 114px;
        height: 1px;
        background: linear-gradient(
            90deg,
            #36c47c 0%,
            rgba(54, 196, 124, 0) 100%
        );
        position: relative;
        top: -45px;
    }
`;

const BrandFeature = styled.div`
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
`;

const Overlay: React.FC<OverlayProps> = ({ title, feature, className }) => {
    return (
        <OverlayContainer className={className}>
            {title}
            <BrandFeature>{feature}</BrandFeature>
        </OverlayContainer>
    );
};

export default Overlay;
